import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../../Buttons/IconButton';
import { noop } from '../../../utilities/functions';

export const ModalHeader = (props) => {
  const { title, onHide, showClose } = props;
  return (
    <div className="react-modal-header">
      {title && <h4 className="react-modal-title">{title}</h4>}
      {showClose && (
        <IconButton
          icon="times"
          className="close"
          onClick={onHide}
          hiddenLabel="Close"
        />
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  showClose: PropTypes.bool,
  title: PropTypes.string,
  onHide: PropTypes.func,
};

ModalHeader.defaultProps = {
  showClose: true,
  title: null,
  onHide: noop,
};
